// extracted by mini-css-extract-plugin
export default {"round_pill":"ShowPlanDetails_round_pill__DmZpD","text_plan":"ShowPlanDetails_text_plan__z5Awq","my_plan":"ShowPlanDetails_my_plan__ZY2b1"};